import Style from "@client/controls/HTML/Style/component";
import { registerGoogleFont } from "@client/lib/fonts";
import { getTextStyle } from "@client/lib/style";
import { type CompositeSettings } from "@client/types";
import React from "react";

const mainCtpl = `%selector% {
  %style%
}`;

export type TextStyleProps = {
  selector: string;
  value: Partial<CompositeSettings.Text> | null | undefined;
};
const TextStyle = (props: TextStyleProps) => {
  registerGoogleFont(props.value?.font);

  const mainData = React.useMemo(() => {
    if (!props.value) return null;

    const style = getTextStyle(props.value);
    if (!style || !Object.keys(style).length) return null;

    return {
      selector: props.selector,
      style
    };
  }, [props.selector, props.value]);

  return <>{!!mainData && <Style ctpl={mainCtpl} data={mainData} />}</>;
};
export default TextStyle;
